import Dashboard from "../components/pages/Dashboard";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const ENDPOINTS = {
  ENTRETIEN: `${API_BASE_URL}/Entretien`,
  // Authentication
  LOGIN: `${API_BASE_URL}/Utilisateur/login`,
  
  // Articles
  ARTICLES: `${API_BASE_URL}/Article`,
  ARTICLE_BY_ID: (id) => `${API_BASE_URL}/Article/${id}`,
  
  // Future endpoints - add as needed
  USERS: `${API_BASE_URL}/Utilisateur`,
  INTERVENTIONS: `${API_BASE_URL}/Intervention`,
  CLIENTS: `${API_BASE_URL}/Client`,
  SERVICES: `${API_BASE_URL}/Services`,
  CERTIFICATS: `${API_BASE_URL}/Certificat`,
  LOCAUX: `${API_BASE_URL}/Local`,
  PIECES_RECHANGE: `${API_BASE_URL}/PieceDeRechange`,
  FAMILLE_TYPE_ARTICLE: `${API_BASE_URL}/FamilleTypeArticle`,
  TYPE_ARTICLE: `${API_BASE_URL}/TypeArticle`,
  ARTICLE_HISTORY: `${API_BASE_URL}/Intervention/HistoriqueArticle`,
  GET_ARTICLE_PIECES: `${API_BASE_URL}/Article/PieceArticle/`,
  GET_BY_CODE_A_BARRE: (codeABarre) => `${API_BASE_URL}/Article/byCodeaBarre/${codeABarre}`,
  DASHBOARD: `${API_BASE_URL}/Dashboard`, 
};

export default ENDPOINTS;